import Vue                      from "vue";
import { mapGetters }           from "vuex";
import DnFunctionButton         from "@/components/Elements/DnFunctionButton.vue"
import { EntitlementsService }  from "@/services/";
import { ErrorLogService }      from "@/services/ErrorLogService"
import  DnTable  from "@/components/Elements/DnTable/DnTable.vue";

export default Vue.extend({
    name: "CorePurchaseRequest",
    components: { DnFunctionButton, DnTable },
    mixins: [],
    created() {
        this.partsListColumns[0].label = this.getContentItem("PartNumber");
        this.partsListColumns[1].label = this.getContentItem("description");
        this.partsListColumns[2].label = this.getContentItem("quantity");
        
        this.submittedPartsListColumns[0].label = this.getContentItem("PartNumber");
        this.submittedPartsListColumns[1].label = this.getContentItem("description");
        this.submittedPartsListColumns[2].label = this.getContentItem("quantity");
    },
    computed: {
        ...mapGetters([
            "getContentItem",
            "user",
            "activeAccountId",
            "SiteName"
        ]),
        showPartsList() {
            return this.partsList.length > 0;
        }
    },
    data: () => ({
        isSubmittingRequest: false,
        isSubmitted: false,
        formDescription: `Use the form below to submit your core purchase requests to us. 
                            Enter in each part number, description, and quantity using the boxes provided. 
                            Clicking the "Add" button will build your request. You may add as many items 
                            to your request as you have available. After we process your request, you will 
                            receive an email with our offer.`,
        formInstructions: `Entitlements will be made available on this site 1 day after your request is 
                            processed and will be available for 10 calendar days. If you choose not to 
                            accept our offer, simply allow the entitlements to expire.`,
        partNumber: "",
        description: "",
        quantity: null,
        partsListColumns: [
            { key: "EnteredOemPartCode", label: "", sortable: false },
            { key: "Description", label: "", sortable: false },
            { key: "Quantity", label: "", sortable: false },
            { key: "RemovePart", label: "", sortable: false },
        ],
        partsList: [],

        // Submit Success Data
        submittedPartsList: null,
        submittedPartsListColumns: [
            { key: "EnteredOemPartCode", label: "", sortable: false },
            { key: "Description", label: "", sortable: false },
            { key: "Quantity", label: "", sortable: false },
        ],
        isFormValid: true
    }),
    methods: {
        addPartToList() {
            this.setFormValidity()
            if( !this.isFormValid){
                return
            }
            
            this.partsList.push({
                EnteredOemPartCode: this.partNumber,
                Description: this.description,
                Quantity: this.quantity
            });
            this.resetPartVariables();
        },
        setFormValidity(){
            this.isFormValid = true
            let warnings = document.getElementsByClassName('text-danger')
            let formWarnings = Array.from(warnings).filter( warning => {
                return warning.id != 'fullFormValidity'
            })
            this.isFormValid = formWarnings.length > 0 ? false : true
        },
        resetPartVariables() {
            this.partNumber = "";
            this.description = "";
            this.quantity = null;
        },
        removePartFromList(part: Object) {
            let indexOfPart = this.partsList.indexOf(part);
            this.partsList.splice(indexOfPart, 1);
        },
        async submitCorePurchase() {
            let errorOccurred = false;
            try {
                this.isSubmittingRequest = true;
                var params = {
                    Id: null,
                    Account: {},
                    ExternalUserId: this.user.UserId,
                    Items: this.partsList,
                    User: null
                }
                let results = await EntitlementsService.CreateCorePurchaseRequest(this.activeAccountId, this.user.UserId, this.SiteName, params);

                this.submittedPartsList = results.data.Items;
            } catch(err) {
                errorOccurred = true;
                ErrorLogService.LogException(err);

                this.$store.commit("pushMessage", {
                    header: "Submission Failed",
                    message: "Core Purchase Request failed. Please try again. If this continues pleace contact support.",
                    IsError: true
                });
            } finally {
                this.isSubmittingRequest = false;

                if (!errorOccurred){
                    this.isSubmitted = true;
                    
                    this.$store.commit("pushTimedMessage", {
                        header: "Success!\nWe have received your core purchase request and will process it shortly. You will receive an email once we have done so.",
                        IsError: false,
                        seconds: 20
                    });
                }
            }
        },
        redirectToReverseLogisticsIndex() {
            this.$router.push("/claimsAndReturns/index");
        },
        restRequestSession() {
            this.resetPartVariables();
            this.partsList = [];
            this.submittedPartsList = [];
            this.isSubmitted= false;
        }
    },
    watch: {
    },
});
